"use client";

import React from "react";
import Image from "next/image";
import {Container} from "@/shared/components/shared";
import {OrtusIcon, StarRating, VlRuIcon} from "@/shared/components/shared/rating-icons";

interface RatingItem {
    platform: string;
    rating: number;
    icon: React.ReactNode;
}

const ratings: RatingItem[] = [
    {
        platform: 'Яндекс',
        rating: 4.8,
        icon: <Image src="/images/reviews/yandex.png" alt="Яндекс" width={84} height={34}
                     className="h-[20px] xl:h-[34px] w-auto object-contain"
                     style={{filter: 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(360deg) brightness(95%) contrast(119%)'}}/>
    },
    {
        platform: '2ГИС',
        rating: 4.5,
        icon: <Image src="/images/reviews/two-gis.png" alt="2ГИС" width={84} height={34}
                     className="h-[20px] xl:h-[34px] w-auto object-contain"
                     style={{filter: 'brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(360deg) brightness(95%) contrast(119%)'}}/>
    },
    {
        platform: 'vl.ru',
        rating: 4.2,
        icon: <VlRuIcon/>
    },
    {
        platform: 'Ортус',
        rating: 4.9,
        icon: <OrtusIcon/>
    }
];

export const Reviews: React.FC = () => {
    return (
        <section className="bg-white">
            <Container className={'py-8 lg:py-12'}>
                <div className="hidden md:block mb-6 md:mb-8 lg:mb-16 text-center">
                    <h2 className={'uppercase text-custom-black font-bold text-[30px] md:text-[40px] lg:text-[50px] xl:text-[70px] leading-[1.2]'}>
                        Искренние впечатления<br/><span className={"text-custom-orange"}>от Наших гостей</span>
                    </h2>
                </div>

                <div className="flex flex-col md:flex-row gap-3 md:gap-8">
                    {/* Картинка */}
                    <div className={'relative md:w-1/2 flex-shrink-0 overflow-hidden -mx-[22px] md:mx-0'}>
                        <div className={'relative h-full min-h-[333px] w-full'}>
                            <Image
                                src="/images/reviews/ratings.jpg"
                                alt="Счастливые покупатели"
                                fill
                                className="object-cover md:object-cover object-right"
                            />
                            <div
                                className={'hidden md:block absolute right-0 top-0 bottom-0 w-1/5 bg-gradient-to-l from-white to-transparent'}/>
                            <div
                                className="md:hidden absolute inset-0 bg-gradient-to-t from-[rgba(38,38,38,0.76)] from-10.56% via-transparent via-5.11% to-transparent bg-blend-multiply"/>
                        </div>
                        <div className="md:hidden absolute bottom-0 left-0 z-10 pb-4 px-4">
                            <h2 className={'uppercase text-white font-bold text-[30px] leading-[1.2]'}>
                                Искренние впечатления от наших Гостей
                            </h2>
                        </div>
                    </div>

                    <div className="md:w-1/2 pt-6 md:py-0 flex flex-col">
                        <div className="mb-4 lg:mb-6 pl-4 xl:pl-6">
                            <h3 className="text-[28px] lg:text-[45px] leading-[1.2] text-black uppercase font-medium">
                                Рейтинги
                            </h3>
                        </div>

                        <div className="flex flex-col gap-px bg-custom-orange/20 border-b border-custom-orange/20">
                            {ratings.map((rating, index) => (
                                <div key={index} className="bg-white p-4 xl:p-6">
                                    <div className="flex items-center justify-between">
                                        {/* Иконка платформы */}
                                        <div className="flex items-center text-custom-orange">
                                            {rating.icon}
                                        </div>

                                        {/* Звезды и оценка */}
                                        <div className="flex items-center space-x-3 xl:space-x-6">
                                            <StarRating rating={rating.rating}/>
                                            <span
                                                className="text-[24px] xl:text-[47px] text-custom-orange leading-[1.2]">
                                                {rating.rating}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}